import {Button, Form, Input, Modal} from "antd";
import Selector from "../selector";
import EnhancedModal from "../enhanced-modal";
import {
  MODAL_WIDTH_LG,
  SPAN_ONE_THIRD,
  SPAN_TWO_THIRDS,
  TABLE_COL_MIN_WIDTH_ID,
  TABLE_COL_MIN_WIDTH_NAME
} from "../../styles/constants";
import InfiniteScrollTable from "../infinite-scroll-table";
import {getNodes} from "../../utils/tree";
import MultilanguageInput from "../multilanguage-input";
import {isDictionaryValid, isIDValidWithHelp} from "../../utils/artefactValidators";
import React from "react";
import PerfInput from "../perf-input";

const formItemLayout = {
  labelCol: {span: SPAN_ONE_THIRD},
  wrapperCol: {span: SPAN_TWO_THIRDS}
};

export const DCSCategoryForm = ({
                                  t,
                                  form,
                                  disabled,
                                  onParentModalShow,
                                  isCategoryFormParentModalVisible,
                                  onParentModalHide,
                                  categorisedCubes,
                                  category,
                                  onEditSubmit,
                                  onCreateSubmit,
                                  noParent
                                }) =>
  <Form className="advanced-form">
    <Form.Item
      className="form-item-required"
      label={t("data.item.id.label")}
      validateStatus={form.getFieldValue("CatCode") && isIDValidWithHelp(t, form.getFieldValue("CatCode")).help ? "warning" : null}
      help={form.getFieldValue("CatCode") && isIDValidWithHelp(t, form.getFieldValue("CatCode")).help}
      {...formItemLayout}
    >
      {form.getFieldDecorator("CatCode", {
        getValueFromEvent: e => (e || "").toUpperCase()
      })(
        <PerfInput
          Component={Input}
          title={form.getFieldValue("CatCode")}
          style={{textTransform: "uppercase"}}
          disabled={disabled || category.IDCat !== null}
        />
      )}
    </Form.Item>
    {!noParent && (
      <Form.Item
        label={t("data.item.parent.label")}
        {...formItemLayout}
      >
        {form.getFieldDecorator("ParCode", {
          getValueFromEvent: val => val.toUpperCase()
        })(
          <Selector
            selectTitle={t('scenes.dataManager.builder.categoryForm.parentSelector.select.title')}
            resetTitle={t('scenes.dataManager.builder.categoryForm.parentSelector.reset.title')}
            onDetail={null}
            render={v => (v || "").toUpperCase()}
            onSelect={onParentModalShow}
            onReset={() => form.setFieldsValue({ParCode: null})}
            disabled={disabled}
          />
        )}
        <EnhancedModal
          visible={isCategoryFormParentModalVisible}
          onCancel={onParentModalHide}
          title={t('scenes.dataManager.builder.categoryForm.parentModal.title')}
          width={MODAL_WIDTH_LG}
          footer={<Button onClick={onParentModalHide}>{t('commons.buttons.close.title')}</Button>}
        >
          {isCategoryFormParentModalVisible && (
            <InfiniteScrollTable
              data={getNodes(categorisedCubes, "children", ({ParCode}) => ParCode !== undefined)}
              getRowKey={({CatCode}) => CatCode}
              columns={[
                {
                  title: t("data.item.id.label"),
                  dataIndex: 'CatCode',
                  minWidth: TABLE_COL_MIN_WIDTH_ID
                },
                {
                  title: t("data.item.name.label"),
                  dataIndex: 'labels',
                  minWidth: TABLE_COL_MIN_WIDTH_NAME
                },
                {
                  title: t("data.item.parent.label"),
                  dataIndex: 'ParCode',
                  minWidth: TABLE_COL_MIN_WIDTH_ID
                },
              ]}
              onRowClick={({CatCode}) => {
                form.setFieldsValue({ParCode: CatCode});
                onParentModalHide();
              }}
              multilangStrDataIndexes={["labels"]}
            />
          )}
        </EnhancedModal>
      </Form.Item>
    )}
    <Form.Item
      className={"form-item-required"}
      label={t("data.item.name.label")}
      {...formItemLayout}
    >
      {form.getFieldDecorator("labels")(
        <MultilanguageInput
          title={form.getFieldValue("labels")}
          disabled={disabled}
        />
      )}
    </Form.Item>
    {!disabled && (
      <Form.Item {...formItemLayout}>
        <Button
          type="primary"
          onClick={() => {
            if (
              category.CatCode === null ||
              !isIDValidWithHelp(t, category.CatCode).valid ||
              !isDictionaryValid(category.labels)
            ) {
              Modal.warning({
                title: t('commons.alerts.invalidForm.title'),
                content: t('commons.alerts.invalidForm.content')
              });
            } else {
              if (category.IDCat !== null) {
                onEditSubmit(category);
              } else {
                onCreateSubmit(category);
              }
            }
          }}
        >
          {t('data.cube.saveButton.label')}
        </Button>
      </Form.Item>
    )}
  </Form>;